import Vue from 'vue'
import Vuex, { mapActions } from 'vuex'

import server from '../scripts/server.js';

/* 
  HOWITWORKS 
  These modules each can contain a state, getters, mutations, and actions of their own.
*/

import account      from './modules/account';
import company      from './modules/company';
import invite       from './modules/invite';
import notification from './modules/notification';
import property     from './modules/property';
import report       from './modules/report';
import role         from './modules/role';
import roleTemplate from './modules/roleTemplate';
import ticket       from './modules/ticket';
import ticketChat   from './modules/ticketChat';
import ticketNote   from './modules/ticketNote';
import ticketTag    from './modules/ticketTag';
import unit         from './modules/unit';
import unitType     from './modules/unitType';
import user         from './modules/user';
import verification from './modules/verification';

// Redefine request types so they return a promise directly
server.getReq = function (path, config) {
  return new Promise((resolve, reject) => {
    server.get(path, config)
    .then(res => {
      return resolve(res.data);
    })
    .catch(e => {
      return reject(e.data);
    });
  });
};

server.delReq = function (path, config) {
  return new Promise((resolve, reject) => {
    server.delete(path, config)
    .then(res => {
      return resolve(res.data);
    })
    .catch(e => {
      return reject(e.data);
    });
  });
};

server.putReq = function (path, data, config) {
  return new Promise((resolve, reject) => {
    server.put(path, data, config)
      .then(res => {
      return resolve(res.data);
    })
    .catch(e => {
      return reject(e.data);
    });
  });
};

server.postReq = function (path, data, config) {
  return new Promise((resolve, reject) => {
    server.post(path, data, config)
    .then(res => {
      return resolve(res.data);
    })
    .catch(e => {
      return reject(e.data);
    });
  });
};

var reauthenticating = false;
window.server = server;

// Server Interceptor - HOWITWORKS - This handles anything that could interrupt the normal flow, such as a token expiring. We can intercept these error codes, try to resolve them, and then run the original request without the end user noticing.
window.server.interceptors.request.use(request => {
  console.log('\n\n--> Server Request:', request.url, request.data || '');
  return request;
});

window.server.interceptors.response.use(response => {
    
  console.log('<-- Server Response:', response.request.responseURL, response.data);

  // Token Expired
  if (response.data.error) {

    // Reauthenticate
    if (response.data.error.code === 40013) {
      
      if (reauthenticating) {

        return new Promise( (resolve, reject) => {
          document.addEventListener('newAccessToken', () => {
            response.config.headers.Authorization = 'bearer ' + window.AppData.$store.getters.token.access_token;
            return resolve(window.server.request(response.config));
          }, {
            once: true
          });
        });

      } else if (!reauthenticating) {
        reauthenticating = true;

        return window.server.post('oauth/token2', {
          grant_type: 'refresh_token',
          refresh_token: window.AppData.$store.getters.token.refresh_token
        })
        .then(res => {
          AppData.$store.commit('storeToken', res.data);
          response.config.headers.Authorization = 'bearer ' + window.AppData.$store.getters.token.access_token;
          reauthenticating = false;

          return window.server.request(response.config);
        })
        .then( (res) => {

          // Send an event to signal the other requests to fire
          var event = document.createEvent('CustomEvent');
          event.initCustomEvent('newAccessToken', false, false, { });
          document.dispatchEvent(event);

          return Promise.resolve(res);
        })
        .catch(e => {
          console.log('Axios intercept error: refreshAuthenticate Error:', e);
          Toast.show('Please login to continue.', 'notify');
          
          // Still not working? Clear user and start over
          AppData.$store.commit('clearToken');
          AppData.$store.commit('clearProfile');
        });
      }
    }
    
    // Token Invalid
    else if (response.data.error.code === 40038) {

      setTimeout(function () {

        if (response.config.headers.Authorization !== 'bearer ' + window.AppData.$store.getters.token.access_token) {
          response.config.headerse.Authorization = 'bearer ' + window.AppData.$store.getters.token.access_token;
          return window.server.request(repsonse.config);
        }
        else {
          Toast.show('Your session has expired. Please login to continue.', 'notify');
          AppData.$store.commit('clearToken');
          AppData.$store.commit('clearProfile');
        }

      }, 200);

    }
    
    else throw(response);
  }
  else {
    // Everything Fine
    return response;
  }


}, error => {
  console.log('Error in the interception');
  return Promise.reject(error);
});

Vue.use(Vuex);

// This root store file only contains authorization logic, user data, and push tokens. All other data is managed via modules.
export const store = new Vuex.Store({
  
  actions: {

    contactMessage ({commit, dispatch}, params) {

      if (!params.email) {
        return Promise.reject('state.contactMessage - Missing required param "email"', params);
      }
      else if (!params.message) {
        return Promise.reject('state.contactMessage - Missing required param "message"', params);
      }
      
      return window.server.postReq('/email/contact', {
        email: params.email,
        message: params.message
      })
      .then(data => {
        return Promise.resolve(data);
      }) 
      .catch(e => {
        console.log('store - actions.contactMessage Error:', e);
        return Promise.reject(e);
      });

    },
    
    clearStore ({commit, dispatch}) {
      commit('clearToken');
      commit('clearCompany');
      commit('clearProfile');

      commit('clearInvites');
      commit('clearNotifications');
      commit('clearProperties');
      commit('clearRoles');
      commit('clearRoleTemplates');
      commit('clearTickets');
      commit('clearTicketChats');
      commit('clearTicketNotes');
      commit('clearTicketTags');
      commit('clearUnits');
      commit('clearUnitTypes');
      commit('clearUsers');
    }

  },
  
  modules: {
    account,
    company,
    invite,
    notification,
    property,
    report,
    role,
    roleTemplate,
    ticket,
    ticketChat,
    ticketNote,
    ticketTag,
    unit,
    unitType,
    user,
    verification
  }
  
});


// WEBPACK FOOTER //
// ./src/store/store.js